<template>
  <div v-if="visible" class="modal-overlay" @click.self="close">
    <div class="modal-container glass-modal-container modal-details">
      <div class="modal-header glass-modal-header">
        <h3>Dispute Details</h3>
        <button class="modal-close" @click="close">×</button>
      </div>
      <div class="modal-body">
        <div class="details-grid" v-if="dispute">
          <div class="detail-item">
            <label>Invoice #</label>
            <div class="detail-value">{{ dispute.invoice_id }}</div>
          </div>
          <div class="detail-item">
            <label>Customer Name</label>
            <div class="detail-value">{{ getCustomerName() }}</div>
          </div>
          <div class="detail-item">
            <label>Customer Phone</label>
            <div class="detail-value">{{ getCustomerPhone() }}</div>
          </div>
          <div class="detail-item">
            <label>Customer Email</label>
            <div class="detail-value">{{ getCustomerEmail() }}</div>
          </div>
          <div class="detail-item">
            <label>Dispute Type</label>
            <div class="detail-value">{{ formatDisputeType() }}</div>
          </div>
          <div class="detail-item">
            <label>Status</label>
            <div class="detail-value">
              <span :class="dispute.status === 'resolved' ? 'status-resolved' : 'status-open'" class="status-badge">
                {{ dispute.status === 'resolved' ? 'Resolved' : 'Open' }}
              </span>
            </div>
          </div>
          <div class="detail-item">
            <label>Finance Company</label>
            <div class="detail-value">{{ dispute.dispute_company_name || dispute.finance_company_name || '-' }}</div>
          </div>
          <div class="detail-item">
            <label>Customer Statement</label>
            <div class="detail-value">{{ dispute.customer_statement === 'received' ? 'Received' : 'Not Received' }}</div>
          </div>
          <div class="detail-item">
            <label>Issue Type</label>
            <div class="detail-value">{{ formatIssueType() }}</div>
          </div>
          <div class="detail-item">
            <label>Resolution</label>
            <div class="detail-value">{{ formatResolution() }}</div>
          </div>
          <div class="detail-item">
            <label>Money Lost</label>
            <div class="detail-value">{{ dispute.money_lost ? 'Yes' : 'No' }}</div>
          </div>
          <div class="detail-item">
            <label>Created Date</label>
            <div class="detail-value">{{ formatDate(dispute.created_at) }}</div>
          </div>
          <div class="detail-item" v-if="dispute.resolved_at">
            <label>Resolved Date</label>
            <div class="detail-value">{{ formatDate(dispute.resolved_at) }}</div>
          </div>
          <div class="detail-item full-width">
            <label>Dispute Details</label>
            <div class="detail-value">{{ dispute.details || 'No additional details provided.' }}</div>
          </div>
          <div class="detail-item full-width" v-if="dispute.resolution_notes">
            <label>Resolution Notes</label>
            <div class="detail-value">{{ dispute.resolution_notes }}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer glass-modal-footer">
        <button class="btn-secondary glass-btn" @click="close">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailsModal',
  props: {
    visible: { type: Boolean, default: false },
    dispute: { type: Object, default: null }
  },
  methods: {
    getCustomerName() {
      return this.dispute && this.dispute.customer ? this.dispute.customer.fullname : 'N/A'
    },
    getCustomerPhone() {
      return this.dispute && this.dispute.customer ? this.dispute.customer.phone : 'N/A'
    },
    getCustomerEmail() {
      return this.dispute && this.dispute.customer ? this.dispute.customer.email : 'N/A'
    },
    formatDisputeType() {
      const types = {
        'customer': 'Customer',
        'credit_card': 'Credit Card',
        'snap_finance': 'Finance',
        'merchant_service': 'Merchant Service',
        'attorney': 'Attorney',
        'court': 'Court'
      }
      return this.dispute ? (types[this.dispute.dispute_type] || this.dispute.dispute_type) : ''
    },
    formatIssueType() {
      const types = {
        'fraud_charges': 'Fraud Charges',
        'broken_merchandise': 'Broken Merchandise',
        'wrong_item': 'Wrong Item',
        'missing_item': 'Missing Item',
        'not_as_described': 'Not as Described',
        'delivery_issue': 'Delivery Issue',
        'other': 'Other'
      }
      return this.dispute ? (types[this.dispute.issue_type] || this.dispute.issue_type) : ''
    },
    formatResolution() {
      const resolutions = {
        'customer_favor': "Customer's Favor",
        'business_favor': "Business's Favor",
        'partial_refund': 'Partial Refund',
        'full_refund': 'Full Refund',
        'replacement': 'Replacement',
        'chargeback_won': 'Chargeback Won',
        'chargeback_lost': 'Chargeback Lost',
        'legal_action': 'Legal Action',
        'pending': 'Pending Resolution'
      }
      return this.dispute ? (resolutions[this.dispute.resolution] || this.dispute.resolution) : ''
    },
    formatDate(date) {
      if (!date) return 'N/A'
      const d = new Date(date)
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  overflow-y: auto;
  padding: 20px;
}

.modal-container {
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: modalSlideIn 0.3s ease;
  margin: auto;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 24px;
}

@keyframes modalSlideIn {
  from { transform: translateY(-30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.98);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 24px 24px 0 0;
}

.modal-close {
  background: transparent;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #94a3b8;
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.modal-footer {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: rgba(255, 255, 255, 0.98);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0 0 24px 24px;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.detail-item {
  margin-bottom: 8px;
}

.detail-item.full-width {
  grid-column: span 2;
}

.detail-item label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-value {
  font-size: 14px;
  color: #1e293b;
  word-break: break-word;
}

.status-badge {
  display: inline-block;
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-open {
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
}

.status-resolved {
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
}

.btn-secondary {
  background: rgba(241, 245, 249, 0.9);
  color: #475569;
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-radius: 10px;
  padding: 10px 20px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/DisputedOrders/components/DetailsModal.vue